import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import BackgroundCard from '../../../../Common/P2P/Header/BackgroundCard';
import RecentTransactionsForm from './RecentTransactionsForm';
import FooterBar from '../../../../Common/P2P/Header/FooterBar';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCashLedgerRequest } from '../dashboardAction';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import ReviewIconTwo from '../../../../utils/assests/new-rev-2.png';
import BorrowIconOne from '../../../../utils/assests/borrower-info.jpg';
import ReviewIconThree from '../../../../utils/assests/new-rev-3.png';
import RecentTransactionsIcon from '../../../../utils/assests/recent-transaction-icon.png';

function RecentTransactions() {
  let dispatch = useDispatch();
  const history = useHistory();
  const [sortedTransaction, setSortedTransaction] = useState<any>(null);
  const [errorMessage, setErrorMessage] = useState<any>('');
  const { cashLedgerSummary } = useSelector((state: any) => state.dashboard);

  useEffect(() => {
    dispatch(getCashLedgerRequest());
  }, []);

  useEffect(() => {
    if (cashLedgerSummary?.data?.cash_ledger?.length > 0) {
      const sorted = cashLedgerSummary?.data?.cash_ledger.sort(
        sortTransactionHistory
      );
      setSortedTransaction(sorted.slice(0, 3));
    } else {
      setErrorMessage(cashLedgerSummary?.message);
    }
  }, [cashLedgerSummary]);

  const sortTransactionHistory = (a: any, b: any) => {
    if (b.transaction_date < a.transaction_date) {
      return 1;
    }
    if (b.date > a.date) {
      return -1;
    }
    return 0;
  };

  const handleInvestmentSummary = () => {
    history.push('/p2p/investmentSummaryInfo');
  };

  const handleBorrowerInfo = () => {
    history.push('/p2p/borrowerInfo');
  };

  const handleKnowMore = () => {
    history.push({
      pathname: '/p2p/transactions',
    });
  };

  const Item = styled(Paper)(({ theme }: any) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  return (
    <>
      <Box className='pageHeadingText'>
        <Typography variant='h6'>
          Review your <strong>investments</strong> <br /> across categories
        </Typography>
      </Box>

      <BackgroundCard>
        <Card className='redBorder'>
          <CardContent>
            <Grid
              container
              alignItems='center'
              justifyContent='center'
              columnSpacing={2}
              className='smallCardHeading'
            >
              <Grid item>
                <img src={RecentTransactionsIcon} alt='' width='100%' />
              </Grid>
              <Grid item>
                <Typography variant='h2'>
                  Recent <br />
                  transactions
                </Typography>
              </Grid>
            </Grid>
            <RecentTransactionsForm
              sortedTransaction={sortedTransaction}
              handleKnowMore={handleKnowMore}
            />

            {/* <Box sx={{ width: 1, marginTop: '20px' }}>
        <Box display='grid' gridTemplateColumns='repeat(12, 1fr)' gap={2}>
          <Box onClick={handleBorrowerInfo} gridColumn='span 4'>
            <Item>Borrower infomation</Item>
          </Box>
          <Box onClick={handleInvestmentSummary} gridColumn='span 4'>
            <Item>Investment summary</Item>
          </Box>
        </Box>
      </Box> */}
          </CardContent>
        </Card>
        <Grid
          container
          spacing={3}
          justifyContent='center'
          alignItems='center'
          className='threeCards'
        >
          <Grid item xs={4}>
            <Card className='redBorder' onClick={handleBorrowerInfo}>
              <CardContent>
                <img src={BorrowIconOne} alt='' />
              </CardContent>
            </Card>
            <Typography className='fs-14 fw-700 text-center text-blue'>
              Borrower <br /> information
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Card className='redBorder' onClick={handleInvestmentSummary}>
              <CardContent>
                <img src={ReviewIconTwo} alt='' />
              </CardContent>
            </Card>{' '}
            <Typography className='fs-14 fw-700 text-center text-blue'>
              Investment <br /> summary
            </Typography>
          </Grid>
        </Grid>

        <FooterBar />
      </BackgroundCard>
    </>
  );
}
export default RecentTransactions;
